import { useCallback, useRef } from 'react';
import type { InterceptorFn, InterceptorStoreT, StageEventType } from '../types';
export function useInterceptors() {
  const interceptorStoreRef = useRef<InterceptorStoreT>({});
  const addInterceptor = useCallback((event: StageEventType, fn: InterceptorFn) => {
    const chain = interceptorStoreRef.current[event];
    if (!chain) {
      interceptorStoreRef.current = {
        ...interceptorStoreRef.current,
        [event]: [fn]
      };
      return;
    }
    if (!chain.includes(fn)) chain.push(fn);
  }, []);
  const removeInterceptor = useCallback((event: StageEventType, fn: InterceptorFn) => {
    const chain = interceptorStoreRef.current[event];
    if (!chain) return;
    const idx = chain.indexOf(fn);
    if (idx !== -1) chain.splice(idx, 1);
  }, []);
  return {
    interceptorStoreRef,
    addInterceptor,
    removeInterceptor
  };
}